import * as Yup from 'yup';

export const areasOfImprovementSchema = Yup.object().shape({
    comment: Yup.string().required('Enter feedback'),
    rating: Yup.string().required('Please select a rating').nullable(),
});
